
import { Modal, Carousel, Button, Image, Container, Row, Col } from "react-bootstrap";


function ModalApp({ show, handleClose, project }) {

    return (
        <Modal show={show} onHide={handleClose}
            aria-labelledby="contained-modal-title-vcenter" centered style={{ border: 0 }}>
            <Modal.Header closeButton style={{ backgroundColor: "#000" }}>
                <Modal.Title>{project.name}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ height: 550, backgroundColor: "#000" }}>
                <Carousel>
                    <Carousel.Item style={{ height: 550, paddingTop: 15, paddingLeft: 60, paddingRight: 60 }}>
                        <Container className="h-75">
                            <Row className="h-100">
                                <Col className="my-auto">
                                    <p className="text-center" style={{ color: "#fff" }}>{project.data.description}</p>
                                    <br></br>

                                    <p className="text-center" style={{ color: "#fff", fontWeight: "bold" }}>Technologies</p>
                                    <lu className="d-flex justify-content-center">
                                        <div>
                                            {project.data.technologies.map((i) => <li style={{ color: "rgb(255, 255, 255, 0.8)" }}>{i}</li>)}
                                        </div>
                                    </lu>
                                </Col>
                            </Row>
                        </Container>
                    </Carousel.Item>

                    {
                        project.data.images.map((item, index) =>

                            <Carousel.Item key={index} style={{ height: 550, width: "100%", paddingTop: 15, paddingLeft: 60, paddingRight: 60 }}>
                                <Container className="h-100 w-100">
                                    <Row className="h-100">
                                        <Col className="d-flex justify-content-center">
                                            <Image src={item} style={{ height: 490 }} />
                                        </Col>
                                    </Row>
                                </Container>
                            </Carousel.Item>
                        )
                    }
                </Carousel>
            </Modal.Body>
            {
                project.data.link !== "" ?

                    <Modal.Footer style={{ backgroundColor: "#000", border: 0 }} >
                        <Button variant="light" href={project.data.link}>Download apk here</Button>
                    </Modal.Footer> : <></>
            }
        </Modal >
    );
}


export default ModalApp;